import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivProductTitleFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  ${mq.sp} {
    flex-direction: column;
    gap: 0px;
  }
`;
